import React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';

import { useDebriefRouter } from 'ff/debrief/hooks';
import * as API from 'ff/debrief/features/TracklogApi';

const LinkToSharedHome = React.forwardRef<
    HTMLAnchorElement,
    React.PropsWithChildren
>(function LinkToSharedHome(props, ref) {
    const { ...rest } = props;
    const { getSharedRouteString } = useDebriefRouter();
    const sharedTracklogsQuery = API.useGetAllSharedTracklogsQuery();
    const firstItem = sharedTracklogsQuery.data && sharedTracklogsQuery.data[0];
    const pathString = getSharedRouteString(firstItem?.shareUuid);
    if (pathString)
        return (
            <UnstyledLink ref={ref} to={pathString} {...rest}>
                {props.children}
            </UnstyledLink>
        );
    else return null;
});

const UnstyledLink = styled(Link)`
    text-decoration: inherit;
    color: inherit;
`;

export default LinkToSharedHome;
